// @ts-nocheck

import { useHistory } from 'react-router';
import {
  processListing,
  setMarkerParams,
  processTailoredRegionMarkers,
  processBookingData,
  makeLowerCase,
  isEmpty,
  calculateRevenuePotentialRange,
  calculatePriceTiers,
  getBoundedListings,
  getFilteredListings,
  getVisibleListings,
  convertBoundsArrayToObj,
  isLeapYear,
  fetchMonthlyHistoricalData,
  processMonthlyHistoricalData,
  brightConsole,
  parseMessageHistoricalData,
  calculateDashboardFilters,
  storeVisitedMarketInLocalStorage,
  removeAccent,
} from 'src/utils/functions';
import {
  GET_GRAPH_LOAD_END,
  GET_GRAPH_LOAD_START,
  GET_SEARCH_LOAD_END,
  GET_SEARCH_LOAD_START,
  GET_MARKERS_LOAD_START,
  GET_MARKERS_LOAD_END,
  GET_MULTIPLE_MARKERS_CALL_LOAD_START,
  GET_MULTIPLE_MARKERS_CALL_LOAD_END,
  GET_TAILORED_REGION_MARKERS_SUCCESS,
  GET_REVIEW_STREAM_LOAD_START,
  GET_REVIEW_STREAM_LOAD_END,
  GET_BOOKING_CHANGES_LOAD_START,
  GET_BOOKING_CHANGES_LOAD_END,
  GET_FILTERED_BOOKINGS_LOAD_START,
  GET_FILTERED_BOOKINGS_LOAD_END,
  SEARCH_CHANGE,
  SET_USER_INFO,
  GET_COMPSETS_LOAD_START,
  GET_COMPSETS_LOAD_END,
  GET_COMPSET_LOAD_START,
  GET_COMPSET_LOAD_END,
  GET_COMPSET_LISTING_IDS_LOAD_START,
  GET_COMPSET_LISTING_IDS_LOAD_END,
  SET_IS_USER_ALLOWED,
  GET_USER_AIRBNB_LISTINGS_LOAD_START,
  GET_USER_AIRBNB_LISTINGS_LOAD_END,
  GET_LISTING_PRICING_RECOMMENDATION_LOAD_START,
  GET_LISTING_PRICING_RECOMMENDATION_LOAD_END,
  SET_CURRENCY,
  SET_SEARCH_LIMIT_BOX_ALERT,
  GET_BOOKING_DATA_LOAD_START,
  GET_BOOKING_DATA_LOAD_END,
  GET_BOOKING_MULTIPLE_MARKERS_LOAD_START,
  GET_BOOKING_MULTIPLE_MARKERS_LOAD_END,
  GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START,
  GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END,
  SET_REV_POTENTIAL_RANGE_INVESTMENT,
  EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  SET_BOUNDS_MAP_INSIGHTS,
  SET_FILTERS_INSIGHTS,
  SET_FILTER_INSIGHTS_ACTIVE,
  SET_USER_COUNTRY_CODE,
  SET_INDIVIDUAL_REV_POTENTIAL_RANGE,
  SET_HISTORICAL_DATA,
  SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR,
  GET_CACHED_SEARCH_MARKETS,
  SET_AIRBTICS_PRO_BANNER_VISIBLE,
  SET_TOP_BANNER_OPEN,
  SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE,
  SET_SEARCHED_MARKET_ESTIMATOR,
  SET_MARKET_CACHED_DATA,
  GET_MARKET_CACHED_DATA,
  SET_MARKET_DASHBOARD_FILTER_DATA,
  SET_PRICE_TIERS,
  UPDATE_PRICE_TIERS,
  SET_EXPLORER_MARKETS,
  GET_EXPLORER_MARKETS,
  GET_ADVANCED_MARKERS_LOAD_START,
  GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_END,
  GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_START,
  GET_ADVANCED_MARKERS_LOAD_END,
  GET_FUTURE_DAILY_DATA_LOAD_START,
  GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_END,
  GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_START,
  GET_FUTURE_DAILY_DATA_LOAD_END,
  SET_LOCKED_MARKET_DUMMY_DATA,
  SET_IS_CACHED_MARKET_DATA_SAMPLE,
  GET_MARKET_MONTHLY_PERFORMANCE_LOAD_START,
  GET_MARKET_MONTHLY_PERFORMANCE_LOAD_END,
  SET_LEAD_FORM_SOURCE,
  DEDUCT_ESTIMATOR_CREDIT,
  SET_USED_VERIFIED,
  SET_VISIBLE_LISTING_IDS,
  GET_VISIBLE_MAP_SUPPLY_LOAD_START,
  SET_VISIBLE_MAP_SUPPLY,
  SET_TOP_10_MARKETS_COUNTRY_WISE,
  SET_ADVANCED_FILTER_ACTIVE_STATE,
  SET_TOP_HOSTS,
  SET_HIDDEN_SUBMARKETS,
  GET_HIDDEN_SUBMARKETS_LOAD_START,
  GET_CLUSTERS_LOAD_START,
  GET_CLUSTERS_LOAD_END,
  GET_DAILY_OCCUPANCY_RATE_CALENDAR_LOAD_START,
  SET_DAILY_OCCUPANCY_RATE_CALENDAR_DATA,
  GET_MARKET_CACHED_DATA_WITH_FILTERS,
  SET_MARKET_CACHED_DATA_WITH_FILTERS,
  SET_NO_DATA_WITH_CURRENT_FILTER,
  SET_MARKET_CACHED_DATA_LAZY_LOADING,
} from 'src/store/Dashboard/types';
import {
  Listing,
  Search,
  Graph,
  ReviewStream,
  BookingChanges,
  RateAndAvailChanges,
  TailoredRegionMarkers,
  NearbyRecommendedMarket,
  CachedSearchedMarketsType,
  FilteredListingsDashboardDataType,
  PriceTiers,
  Bounds,
} from '../../interfaces/idashboard';
import { User } from '../../interfaces/iuser';
import { AppDispatch } from '../../core/StoreProvier/StoreProvider';
import { CompsetFilterVal } from 'src/interfaces/iproptypes';
import {
  OVERVIEW_DASHBOARD_FILTER_DEMO_DATA,
  daysInMonth,
  fuseSearchOptions,
  sampleMarket,
  DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE,
  GET_MARKET_DATA_CACHE_URL,
  GET_TOP_HOST_DETAILS_URL,
} from 'src/const';
// import demoGranularDataDaily from 'src/demoGranularDataDaily';
import { callApi } from 'src/core/callApi';
import pako from 'pako';
import Fuse from 'fuse.js';
import axios from 'axios';

const getMarkersLoadStart = () => ({
  type: GET_MARKERS_LOAD_START,
});

export const setListings = (payload: Listings) => ({
  type: GET_MARKERS_LOAD_END,
  payload,
});

const getMultipleMarkersCallLoadStart = () => ({
  type: GET_MULTIPLE_MARKERS_CALL_LOAD_START,
});

const getMultipleMarkersCallLoadEnd = () => ({
  type: GET_MULTIPLE_MARKERS_CALL_LOAD_END,
});

const getTailoredRegionMarkersSuccess = (payload: TailoredRegionMarkers[]) => ({
  type: GET_TAILORED_REGION_MARKERS_SUCCESS,
  payload,
});

const getGraphLoadStart = () => ({
  type: GET_GRAPH_LOAD_START,
});

const getGraphLoadEnd = (payload: Graph) => ({
  type: GET_GRAPH_LOAD_END,
  payload,
});

export const getSearchLoadStart = () => ({
  type: GET_SEARCH_LOAD_START,
});

export const getSearchLoadEnd = () => ({
  type: GET_SEARCH_LOAD_END,
});

const getReviewStreamLoadStart = () => ({
  type: GET_REVIEW_STREAM_LOAD_START,
});

const getReviewStreamLoadEnd = (payload: ReviewStream) => ({
  type: GET_REVIEW_STREAM_LOAD_END,
  payload,
});

const getBookingChangesLoadStart = () => ({
  type: GET_BOOKING_CHANGES_LOAD_START,
});

const getBookingChangesLoadEnd = (payload: BookingChanges) => ({
  type: GET_BOOKING_CHANGES_LOAD_END,
  payload,
});

const getMultipleBookingDataLoadStart = () => ({
  type: GET_BOOKING_MULTIPLE_MARKERS_LOAD_START,
});

const getMultipleBookingDataLoadEnd = () => ({
  type: GET_BOOKING_MULTIPLE_MARKERS_LOAD_END,
});

const getFilteredBookingsLoadStart = () => ({
  type: GET_FILTERED_BOOKINGS_LOAD_START,
});

export const setFilteredBookings = (payload: RateAndAvailChanges[]) => ({
  type: GET_FILTERED_BOOKINGS_LOAD_END,
  payload,
});

export const setEstimatorSearchedMarket = payload => ({
  type: SET_SEARCHED_MARKET_ESTIMATOR,
  payload,
});

export const setUserInfo = (payload: User) => ({
  type: SET_USER_INFO,
  payload,
});

export const getCompsetListingIdsLoadStart = () => ({
  type: GET_COMPSET_LISTING_IDS_LOAD_START,
});

export const setAnnualRevenueDataForCalculator = (payload: number) => ({
  type: SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR,
  payload,
});

export const setMaxSampleRevenuePotentialPropertySize = (payload: number) => ({
  type: SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE,
  payload,
});

export const setCompsetListingIds = (payload: number[]) => ({
  type: GET_COMPSET_LISTING_IDS_LOAD_END,
  payload,
});

export const setUserCountryCode = (payload: string) => ({
  type: SET_USER_COUNTRY_CODE,
  payload,
});

export const setIsUserAllowed = payload => ({
  type: SET_IS_USER_ALLOWED,
  payload,
});

export const getBookingDataLoadStart = () => ({
  type: GET_BOOKING_DATA_LOAD_START,
});

export const setBookingData = payload => ({
  type: GET_BOOKING_DATA_LOAD_END,
  payload,
});

const resetMarket = (loginCountryCode, isSubmarket = false) => (
  dispatch: AppDispatch,
  getState
) => {
  const {
    dashboard: { isUserAllowed, search },
  } = getState();

  let dummmyMarketDistrictName = DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE[loginCountryCode][
    'overview'
  ]['district'].toLowerCase();
  const isDummyMarket = search.data.name.toLowerCase() == dummmyMarketDistrictName;

  if (isDummyMarket) {
    dispatch(getMarkers(loginCountryCode, false, 0));
  } else if (!isSubmarket) {
    dispatch(getMultipleMarkersCallLoadEnd());
  }
};

export const getNearbyRecommendedMarketsLoadingStart = () => ({
  type: GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START,
});

export const getNearbyRecommendedMarketsLoadingEnd = payload => ({
  type: GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END,
  payload,
});

export const setRevenuePotentialRange = payload => ({
  type: SET_REV_POTENTIAL_RANGE_INVESTMENT,
  payload,
});

export const setLeadFormSource = payload => ({
  type: SET_LEAD_FORM_SOURCE,
  payload,
});

export const setIndividualRevenuePotentialRange = (payload: {
  [key: number]: 'visible' | 'hidden';
}) => ({
  type: SET_INDIVIDUAL_REV_POTENTIAL_RANGE,
  payload,
});


export const setPriceTiers = (payload: number[]) => ({
  type: SET_PRICE_TIERS,
  payload,
});

export const updatePriceTiers = (payload: PriceTiers) => ({
  type: UPDATE_PRICE_TIERS,
  payload,
});

export const setBoundsMapInsights = (payload: Bounds) => ({
  type: SET_BOUNDS_MAP_INSIGHTS,
  payload: payload,
});

export const setFiltersInsights = payload => ({
  type: SET_FILTERS_INSIGHTS,
  payload: payload,
});

export const setFilterInsightsActive = payload => ({
  type: SET_FILTER_INSIGHTS_ACTIVE,
  payload: payload,
});

export const setVisibleListingIDs = payload => ({
  type: SET_VISIBLE_LISTING_IDS,
  payload: payload,
});

export const getVisibleMapSupplyLoadStart = () => ({
  type: GET_VISIBLE_MAP_SUPPLY_LOAD_START,
});

export const setVisibleMapSupply = payload => ({
  type: SET_VISIBLE_MAP_SUPPLY,
  payload: payload,
});

export const getHiddenSubmarketsLoadStart = () => ({
  type: GET_HIDDEN_SUBMARKETS_LOAD_START,
});

export const setHiddenSubmarkets = payload => ({
  type: SET_HIDDEN_SUBMARKETS,
  payload,
});

export const getDailyOccupancyRateCalendarLoadStart = () => ({
  type: GET_DAILY_OCCUPANCY_RATE_CALENDAR_LOAD_START,
});

export const setDailyOccupancyRateCalendarData = payload => ({
  type: SET_DAILY_OCCUPANCY_RATE_CALENDAR_DATA,
  payload,
});

export const getDistrictInfo = (
  loginCountryCode: string,
  district: string,
  city: string,
  country: string,
  getMarketData = true
) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getSearchLoadStart());
  const {
    dashboard: { search },
  } = getState();
  const url = 'https://68gjq7no20.execute-api.us-east-2.amazonaws.com/default/getDistrictInfo';
  // const url = 'https://ney85gkj5f.execute-api.us-east-2.amazonaws.com/default/getDistrictInfoTest';
  const config = {
    district: district,
    city: city,
    country: country,
  };

  try {
    const response = await api(url, { queryParams: config }, true);
    const districtObj = response.message;

    const country = districtObj['country'];
    const city = districtObj['city'];
    const district = districtObj['name'];
    const isUserAllowed = districtObj['isUserAllowed'];

    const newSearchObj = {
      name: district,
      lat: districtObj['lat'],
      lng: districtObj['lng'],
      polygon: districtObj['polygon'],
      multiPolygon: districtObj['multiPolygon'],
      city: city,
      country: country,
      countryCode: districtObj['countryCode'],
      bounds: convertBoundsArrayToObj(districtObj['bounds']),
      recommendPageURLs: districtObj['recommendPageURLs'],
      isTailoredRegion: districtObj['visibility'] == 'private' ? true : false,
      currency: districtObj['currency'],
      isVerified: districtObj['isVerified'],
      marketID: districtObj['marketID'],
      cachedFilesCount: districtObj['cachedFilesCount'],
      annualAppreciation: districtObj['annual_appreciation'],
      property_price: districtObj['property_price'],
      created_by: districtObj['created_by'],
      visibility: districtObj['visibility'],
      id: districtObj['id'],
      marketBlogLink: districtObj['marketBlogLink'],
      isSubmarket: false,
      isUserAllowed: isUserAllowed,
      parentMarketID: districtObj['parentMarketID'],
      displayName: districtObj['displayName'],
    };

    storeVisitedMarketInLocalStorage(newSearchObj);

    isUserAllowed && dispatch(setIsUserAllowed(isUserAllowed));
    console.log('IS USER ALLOWED [ACTION] ', isUserAllowed);

    if (getMarketData) {
      dispatch(
        fetchCachedMarketData(
          newSearchObj.name,
          newSearchObj.city,
          newSearchObj.countryCode,
          newSearchObj.country,
          loginCountryCode
        )
      );
    }

    dispatch(searchChange({ ...search, data: { ...search.data, ...newSearchObj } }));
    dispatch(getSearchLoadEnd());
    dispatch(resetMarket(loginCountryCode));
    dispatch(getGraphData(loginCountryCode));
    dispatch(getClusters(newSearchObj.id));
    getTopHosts(newSearchObj.parentMarketID ? newSearchObj.parentMarketID : newSearchObj.id)(
      dispatch,
      getState,
      api
    );
  } catch (err) {
    console.log('Unhandled error while calling getDistrictInfo ', err);
    dispatch(getSearchLoadEnd());
  }
};

export const getTopHosts = (marketID: string) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(
    setTopHosts({
      data: null,
      loading: true,
      isUserAllowedToHostData: false,
    })
  );

  const url = GET_TOP_HOST_DETAILS_URL;
  const config = {
    marketID: marketID,
    returnUserAccess: true,
  };
  const response = await api(url, { queryParams: config }, true);

  if (!response.message || response.error) {
    dispatch(
      setTopHosts({
        data: null,
        loading: false,
        isUserAllowedToHostData: false,
      })
    );
    return;
  }

  dispatch(
    setTopHosts({
      data: response.message.hosts,
      loading: false,
      isUserAllowedToHostData: response.message.is_user_allowed,
    })
  );
};

export const setTopHosts = (payload: any) => ({
  type: SET_TOP_HOSTS,
  payload,
});

export const getSubmarketInfo = (submarketID: string, loginCountryCode) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getSearchLoadStart());
  const {
    dashboard: { search },
  } = getState();
  const url = 'https://3jg8y4cgz1.execute-api.us-east-2.amazonaws.com/default/handleSubmarket';
  const config = {
    id: submarketID,
  };

  try {
    const response = await api(url, { queryParams: config }, true);
    const submarket = response.message;

    const shiftedNewMarketURLSlug = submarket['shifted_market_url_path'];
    
    if (shiftedNewMarketURLSlug) {
      const newURL = `${window.location.origin}/airbnb-data${shiftedNewMarketURLSlug}`;
      window.location.href = newURL;
      return;
    }

    const newSearchObj = {
      id: submarket['id'],
      name: submarket['name'],
      lat: submarket['lat'],
      lng: submarket['lng'],
      polygon: submarket['polygon'],
      multiPolygon: submarket['multiPolygon'],
      city: submarket['city'],
      country: submarket['country'],
      countryCode: submarket['countryCode'],
      bounds: convertBoundsArrayToObj(submarket['bounds']),
      isTailoredRegion: false,
      currency: submarket['currency'],
      created_by: submarket['created_by'],
      createdDate: submarket['created_date'],
      parentMarketID: submarket['parent_market_id'],
      parentMarketUrlPath: submarket['parent_market_url_path'],
      parentMarketName: submarket['parent_market_name'],
      filters: submarket['filters'],
      isSubmarket: true,
    };

    dispatch(fetchCachedMarketData(null, null, null, null, null, submarket['id']));

    dispatch(searchChange({ ...search, data: { ...search.data, ...newSearchObj } }));
    dispatch(getSearchLoadEnd());
    dispatch(resetMarket(loginCountryCode, true));
    dispatch(getGraphData(loginCountryCode));
  } catch (err) {
    console.log('Unhandled error while calling getSubmarket ', err);
    dispatch(getSearchLoadEnd());
  }
};

// calls getMarkers API in loop for max of 100 times

export const getMarkers = (
  loginCountryCode,
  unlockRegion = false,
  creditsToBeDeducted = 0
) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getMarkersLoadStart());
  dispatch(getMultipleMarkersCallLoadStart());

  const {
    dashboard: { search, boundsMapInsights, filtersInsights, filterInsightsActive },
  } = getState();

  let dummmyMarketDistrictName = DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE[loginCountryCode][
    'overview'
  ]['district'].toLowerCase();

  if (search.data.name.toLowerCase() == dummmyMarketDistrictName) {
    dispatch(setIsUserAllowed(true));
    const url = `https://default-market-data-cache.s3.us-east-2.amazonaws.com/${dummmyMarketDistrictName.replaceAll(
      ' ',
      '_'
    )}.json`;
    const response = await api(url, {}, false);
    const listings = processListing(response.message, response.dates, response.historical_dates);
    dispatch(setRevenuePotentialRange(calculateRevenuePotentialRange(listings)));
    dispatch(setPriceTiers(calculatePriceTiers(listings)));
    dispatch(setListings(listings));
    dispatch(getMultipleMarkersCallLoadEnd());
    dispatch(setMarketDashboardFilter(calculateDashboardFilters(listings, true)));
    return;
  }

  const url = 'https://8a8j1g1opk.execute-api.us-east-2.amazonaws.com/default/getMarkers';
  // const url = 'https://b7oek764te.execute-api.us-east-2.amazonaws.com/default/getMarkersTest';
  let markerParam = { ...search.data };
  delete markerParam.polygon;
  delete markerParam.multiPolygon;
  delete markerParam.lat;
  delete markerParam.lng;
  delete markerParam.bounds;
  delete markerParam.country;

  if (unlockRegion) {
    markerParam = { ...markerParam, unlockRegion: true, creditsToBeDeducted };
  }

  markerParam = { ...markerParam, loginCountry: loginCountryCode };

  if (search.data.isSubmarket) {
    markerParam = { submarketID: search.data.id };
  }

  let listings = {};
  let isUserAllowed = false;
  let callsMade = 0;
  const limit = 5000;

  while (callsMade < 20) {
    try {
      const {
        dashboard: { boundsMapInsights, filtersInsights, filterInsightsActive },
      } = getState();

      const offset = callsMade * limit;
      markerParam = { ...markerParam, limit: limit, offset: offset };

      let response = await api(url, { queryParams: markerParam }, true, true);
      if (response instanceof TypeError && response.message === 'Failed to fetch') {
        console.log('Markers call failed. Retrying...');
        continue;
      }

      let reload = response.reload;
      if (reload) {
        window.location.reload();
        return;
      }
      const listingsFromBE = processListing(response.message, response.isUserAllowed);

      setTimeout(() => {
        listings = { ...listings, ...listingsFromBE };

        if (response.message.length > 0) {
          dispatch(setRevenuePotentialRange(calculateRevenuePotentialRange(listings)));
          dispatch(setPriceTiers(calculatePriceTiers(listings)));
        }

        if (Object.keys(listingsFromBE).length > 0) {
          dispatch(
            setMarketDashboardFilter(calculateDashboardFilters(listings, response.isUserAllowed))
          );
          dispatch(setListings(listings));
        }
      }, callsMade * 1000);

      if (response.message.length < limit) {
        break;
      }

      callsMade += 1;
    } catch (e) {
      console.log('error. Ignore and run again ', e);
    }
  }

  dispatch(getMultipleMarkersCallLoadEnd());
};

export const getHighLowRevPotentialInvestment = () => (dispatch: AppDispatch, getState, api) => {
  const {
    dashboard: { listings },
  } = getState();

  if (listings.data && listings.data.length !== 0) {
    const revPotentialRange: number[] = calculateRevenuePotentialRange(listings.data);
    dispatch(setRevenuePotentialRange(revPotentialRange));
  }
};

export const getBookingData = () => async (dispatch: AppDispatch, getState, api) => {
  return;

  dispatch(getBookingDataLoadStart());
  dispatch(getMultipleBookingDataLoadStart());

  const {
    dashboard: {
      search: {
        data: { name, city, countryCode },
      },
    },
  } = getState();

  if (name.toLowerCase() === sampleMarket) {
    const url = 'https://default-market-data-cache.s3.us-east-2.amazonaws.com/getBookingData.json';
    const response = await api(url, {}, false);
    const bookingData = { ...response.bookings };
    dispatch(setBookingData(bookingData));
    dispatch(getMultipleBookingDataLoadEnd());
    return;
  }

  const url = 'https://3py91q55hg.execute-api.us-east-2.amazonaws.com/default/getBookingData';

  let offset = null;
  let bookingData: any = {};

  let marketParams = { name, city, countryCode };

  for (let i = 0; i < 15; i++) {
    try {
      if (offset) {
        marketParams = { ...marketParams, offset };
      }
      let response = await api(url, { queryParams: marketParams }, true, true);
      offset = response.message.lastListingID;

      const {
        dashboard: { listings },
      } = getState();

      if (response.message) {
        let reload = response.message.reload;
        if (reload) {
          window.location.reload();
          return;
        }

        if (response.message.bookings && !isEmpty(response.message.bookings)) {
          bookingData = { ...bookingData, ...response.message.bookings };
          dispatch(setBookingData(bookingData));
        }
      }
      if (
        response.message.callAgain == false ||
        (response.message.error && response.message.error === 'Unauthorized request')
      ) {
        break;
      }
    } catch (err) {
      console.log('error while making a request to booking details', err);
    }
  }

  dispatch(getMultipleBookingDataLoadEnd());
};

export const getTailoredRegionMarkers = (bounds, passMarketPolygon = false) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  const {
    dashboard: { search },
  } = getState();

  const url =
    'https://rd9s3wn350.execute-api.us-east-2.amazonaws.com/default/getMarkersTailorRegion';
  let markerParam = {};

  let marketBoundary = search.data.polygon;
  if (!marketBoundary) {
    marketBoundary = search.data.multiPolygon;
  }
  setMarkerParams(markerParam, bounds, passMarketPolygon ? marketBoundary : null);

  const response = await api(url, { queryParams: markerParam }, false);
  if (typeof response.message === 'string') {
    return;
  }

  const tailoredRegionMarkers = processTailoredRegionMarkers(response.message);
  dispatch(getTailoredRegionMarkersSuccess(tailoredRegionMarkers));
};

export const getGraphData = loginCountryCode => async (dispatch: AppDispatch, getState, api) => {
  //const url = 'https://1gd0fs8w2c.execute-api.us-east-2.amazonaws.com/default/getGraphData';
  const url = 'https://eo03ieyn04.execute-api.us-east-2.amazonaws.com/default/getGuestOrigin';
  dispatch(getGraphLoadStart());
  let {
    dashboard: { search },
  } = getState();

  let markerParam = { ...search.data };
  delete markerParam.polygon;
  delete markerParam.multiPolygon;
  delete markerParam.bounds;
  delete markerParam.lat;
  delete markerParam.lng;
  delete markerParam.country;

  markerParam = { ...markerParam, loginCountry: loginCountryCode };

  if (search.data.isSubmarket) {
    markerParam = { submarketID: search.data.id, countryCode: search.data.countryCode };
  }

  const response = await api(url, { queryParams: markerParam }, true);
  if (response.message !== 'Failed to fetch') {
    dispatch(getGraphLoadEnd(response.message));
  }
};

export const getReviewStream = () => async (dispatch: AppDispatch, getState, api) => {
  const url = 'https://x5cv061l6c.execute-api.us-east-2.amazonaws.com/default/getReviewStream';
  dispatch(getReviewStreamLoadStart());
  let {
    dashboard: { search },
  } = getState();

  let markerParam = { ...search.data };
  delete markerParam.polygon;
  delete markerParam.multiPolygon;
  delete markerParam.country;
  delete markerParam.lat;
  delete markerParam.lng;
  delete markerParam.zoom;
  delete markerParam.bounds;
  delete markerParam.isTailoredRegion;

  let auth = true;
  if (makeLowerCase(search.data.name) == sampleMarket) {
    auth = false;
  }
  const response = await api(url, { queryParams: markerParam }, auth);
  dispatch(getReviewStreamLoadEnd(response.message));
};

export const getUserInfo = () => async (dispatch: AppDispatch, __, api, _) => {
  const url = 'https://w1ec9zcvbk.execute-api.us-east-2.amazonaws.com/default/getUserInfo';
  const response = await api(url, {}, true);

  if (response && response.message) {
    let user: User = response.message;    
    console.log('[DEV-LOG] user', user);
    if (user == 'Failed to fetch' || user == 'Invalid Auth Token') {
      return;
    }
    const overviewFilters = user.overviewFilters ? JSON.parse(user.overviewFilters) : {};
    dispatch(setUserInfo({ ...user, loading: false }));
    !isEmpty(overviewFilters) && dispatch(setFiltersInsights(overviewFilters));
    if (user.subscriptionPlan === 'expert' || user.subscriptionPlan === 'scale') {
      dispatch(setIsUserAllowed(true));
    }
  }
};

export const searchChange = (payload: Search) => ({
  type: SEARCH_CHANGE,
  payload,
});

// TODO: Change this to fetch coordinates of city
export const getSearch = () => async (dispatch: AppDispatch) => {
  dispatch(getSearchLoadStart());

  dispatch(getSearchLoadEnd());
};

export const setCurrency = (payload: str) => ({
  type: SET_CURRENCY,
  payload,
});

export const getNearbyRecommendedMarkets = (
  searchedMarkets: any[],
  reqMarketsCount: number,
  lastPromise: React.MutableRefObject<any>
) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getNearbyRecommendedMarketsLoadingStart());
  try {
    const url =
      'https://pjm7yob50d.execute-api.us-east-2.amazonaws.com/default/getNearbyRecommendedMarkets';
    const config = {
      queryParams: {
        inputMarkets: JSON.stringify(searchedMarkets),
        number_of_return_markets: reqMarketsCount,
      },
    };

    const currentPromise = api(url, config, true).then(response => {
      return response;
    });
    lastPromise.current = currentPromise;

    currentPromise.then(
      response => {
        if (currentPromise === lastPromise.current) {
          dispatch(getNearbyRecommendedMarketsLoadingEnd(response));
        }
      },
      e => {
        if (currentPromise === lastPromise.current) {
          console.warn('fetch failure', e);
        }
      }
    );
  } catch (err) {
    console.error('Failed to fetch nearby markets!');
    dispatch(getNearbyRecommendedMarketsLoadingEnd([]));
  }
};

// bright pricing
const getUserAirbnbListingsLoadStart = () => ({
  type: GET_USER_AIRBNB_LISTINGS_LOAD_START,
});

const getUserAirbnbListingsLoadEnd = payload => ({
  type: GET_USER_AIRBNB_LISTINGS_LOAD_END,
  payload,
});

const getListingPricingRecommendationLoadStart = () => ({
  type: GET_LISTING_PRICING_RECOMMENDATION_LOAD_START,
});

const getListingPricingRecommendationLoadEnd = payload => ({
  type: GET_LISTING_PRICING_RECOMMENDATION_LOAD_END,
  payload,
});

export const getUserAirbnbListings = () => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getUserAirbnbListingsLoadStart());
  const url =
    'https://hilpzzpeo4.execute-api.us-east-2.amazonaws.com/default/getUserAirbnbListings';
  let userAirbnbListings = [];
  try {
    const response = await api(url, {}, true);
    userAirbnbListings = response.message;
    dispatch(getUserAirbnbListingsLoadEnd(userAirbnbListings));
  } catch (e) {
    console.log('error: ', e);
  }
};

export const getListingPricingRecommendation = (listingID: string, pushPricing: boolean) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  const url =
    'https://5v07hdzm7g.execute-api.us-east-2.amazonaws.com/default/getListingPricingRecommendation';
  try {
    if (pushPricing) {
      const response = await api(
        url,
        { queryParams: { listingID: listingID, pushPricing: true } },
        true
      );
    } else {
      dispatch(getListingPricingRecommendationLoadStart());
      const response = await api(url, { queryParams: { listingID: listingID } }, true);
      dispatch(getListingPricingRecommendationLoadEnd(response));
    }
  } catch (e) {
    console.log('error: ', e);
  }
};

export const setSearchLimitAlertBox = (payload: boolean) => ({
  type: SET_SEARCH_LIMIT_BOX_ALERT,
  payload,
});

const setGoogleAutocompleteSessionToken = payload => ({
  type: SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  payload: payload,
});

export const getGoogleAutocompleteSessionToken = loader => async (dispatch: AppDispatch) => {
  const google = !loader ? (window as any).google : await loader.load();

  const sessionToken = new google.maps.places.AutocompleteSessionToken();
  // console.log('==', sessionToken);
  dispatch(setGoogleAutocompleteSessionToken(sessionToken));
  return sessionToken;
};

export const clearGoogleAutocompleteSessionToken = () => ({
  type: EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
});

export const setHistoricalData = payload => ({
  type: SET_HISTORICAL_DATA,
  payload: payload,
});

export const fetchDemoHistoryFromS3 = async () => {
  const url = 'https://airbtics-resource.s3.us-east-2.amazonaws.com/demoGranularDataDaily.json';
  try {
    const result = await fetchMonthlyHistoricalData(url, false);
    return result;
  } catch (err) {
    console.log('Error while calling demo granularity data: ', err);
    return null;
  }
};

export const setCachedSearchMarkets = payload => ({
  type: GET_CACHED_SEARCH_MARKETS,
  payload,
});

export const setTop10MarketsCountryWise = payload => ({
  type: SET_TOP_10_MARKETS_COUNTRY_WISE,
  payload,
});

// FuseOptions, FuseResultWithMatches

export const getCachedSearchMarkets = () => async (dispatch: AppDispatch) => {
  const marketBuffer = await axios.get(
    'https://airbtics-resource.s3.us-east-2.amazonaws.com/public_markets_compressed_3.json.gz',
    {
      responseType: 'arraybuffer',
      decompress: true,
    }
  );
  let markets: CachedSearchedMarketsType[] = await JSON.parse(
    pako.inflate(marketBuffer.data, { to: 'string' })
  );

  markets = markets.map(market => ({
    ...market,
    searchName: removeAccent(market.displayName) || removeAccent(market.district),
  }));

  const fuse: Fuse<CachedSearchedMarketsType> = new Fuse(markets, fuseSearchOptions);

  dispatch(setCachedSearchMarkets({ fuse, markets }));
};

export const getTop10MarketCountryWise = () => async (dispatch: AppDispatch) => {
  try {
    const top10marketData = await axios.get(
      'https://airbtics-resource.s3.us-east-2.amazonaws.com/public_top_10_best_markets_country_wise.json'
    );
    dispatch(setTop10MarketsCountryWise(top10marketData.data));
  } catch (err) {
    console.error('Error while getting top 10 markets: ', err);
  }
};

export const setTopBannerOpen = (payload: boolean) => ({
  type: SET_TOP_BANNER_OPEN,
  payload,
});

export const fetchDummyDataForLockedMarket = (
  loginCountryCode,
  name: string,
  city: string | 0,
  countryCode: string
) => async (dispatch: AppDispatch, getState, api) => {
  const URL = GET_MARKET_DATA_CACHE_URL;
  // const URL =
  //   'https://43kxfqfm00.execute-api.us-east-2.amazonaws.com/default/getMarketDataCacheTest';
  const TIME_DURATION_TO_CALL_AGAIN = 5; // in seconds

  try {
    const { message } = await api(
      URL,
      { queryParams: { name, city, countryCode, loginCountry: loginCountryCode } },
      true
    );

    if (!message || typeof message == 'string' || message.is_sample) {
      if (message && message.is_sample) {
        const parsedMessage = parseMessageHistoricalData(message);
        dispatch(setLockedMarketDummyData(parsedMessage));
      }
      setTimeout(() => {
        dispatch(fetchDummyDataForLockedMarket(loginCountryCode, name, city, countryCode));
      }, TIME_DURATION_TO_CALL_AGAIN * 1000);
    } else {
      const parsedMessage = parseMessageHistoricalData(message);
      dispatch(setLockedMarketDummyData(parsedMessage));
    }
  } catch (err) {
    brightConsole().error(err);
    setTimeout(() => {
      dispatch(fetchDummyDataForLockedMarket(loginCountryCode, name, city, countryCode));
    }, TIME_DURATION_TO_CALL_AGAIN * 1000);
  }
};

export const setLockedMarketDummyData = (payload: any) => ({
  type: SET_LOCKED_MARKET_DUMMY_DATA,
  payload: payload,
});

export const fetchCachedMarketData = (
  name: string,
  city: string | 0,
  countryCode: string,
  country: string,
  loginCountryCode,
  submarketID = null,
  shouldShowLoading = true,
  shouldOnlyUpdateLazyLoadingData = false,
  callingTimes=0
) => async (dispatch: AppDispatch, getState, api) => {
  const URL = GET_MARKET_DATA_CACHE_URL;
  // const URL =
  //   'https://43kxfqfm00.execute-api.us-east-2.amazonaws.com/default/getMarketDataCacheTest';

  const TIME_DURATION_TO_CALL_AGAIN = 5; // in seconds

  try {
    if (shouldShowLoading) dispatch(setCachedMarketDataLoading());

    const config = submarketID
      ? { submarketID: submarketID }
      : { name, city, countryCode, loginCountry: loginCountryCode, country };

    const { message } = await api(URL, { queryParams: config }, true);
    
    if (
      (!message ||
      typeof message == 'string' ||
      message.is_sample ||
      message.is_cache_outdated ||
      message?.occupancy_breakdown?.daily_historical_data == 'processing' ||
      message?.monthly_booking_data == 'processing') &&
      !submarketID // We will not be rendering the submarkets anymore, let's stop the reload until we remove this as we will show a blur screen 
    ) {
      let shouldShowLoading = true;
      const shouldOnlyUpdateLazyLoadingData = message?.occupancy_breakdown?.daily_historical_data == 'processing' || message?.monthly_booking_data == 'processing';

      if (message && typeof message != 'string') {
        const parsedMessage = parseMessageHistoricalData(message);
        if (shouldOnlyUpdateLazyLoadingData && callingTimes > 0) {
          dispatch(setCachedMarketDataLazyLoading(parsedMessage));
        }else{
          dispatch(setCachedMarketData(parsedMessage));
        }
        shouldShowLoading = false;
      }
      if (message.is_sample) dispatch(setIsCachedMarketDataSample(true));      

      setTimeout(() => {
        dispatch(
          fetchCachedMarketData(
            name,
            city,
            countryCode,
            country,
            loginCountryCode,
            submarketID,
            shouldShowLoading,
            shouldOnlyUpdateLazyLoadingData,
            callingTimes+1
          )
        );
      }, TIME_DURATION_TO_CALL_AGAIN * 1000);
    } else {      
      const parsedMessage = parseMessageHistoricalData(message);
      dispatch(setCachedMarketData(parsedMessage));
      dispatch(setIsCachedMarketDataSample(false));
    }
  } catch (err) {
    brightConsole().error(err);
    setTimeout(() => {
      dispatch(
        fetchCachedMarketData(name, city, countryCode, country, loginCountryCode, submarketID)
      );
    }, TIME_DURATION_TO_CALL_AGAIN * 1000);
  }
};

export const setCachedMarketDataLoading = () => ({
  type: GET_MARKET_CACHED_DATA,
});

export const setCachedMarketDataLazyLoading = (payload: any) => ({
  type: SET_MARKET_CACHED_DATA_LAZY_LOADING,
  payload: payload,
});

export const setCachedMarketData = (payload: any) => ({
  type: SET_MARKET_CACHED_DATA,
  payload: payload,
});

export const setIsCachedMarketDataSample = (payload: boolean) => ({
  type: SET_IS_CACHED_MARKET_DATA_SAMPLE,
  payload: payload,
});

export const setMarketDashboardFilter = (payload: FilteredListingsDashboardDataType) => ({
  type: SET_MARKET_DASHBOARD_FILTER_DATA,
  payload,
});

const getExplorerMarketsLoadStart = () => ({
  type: GET_EXPLORER_MARKETS,
});

export const setExplorerMarkets = payload => ({
  type: SET_EXPLORER_MARKETS,
  payload,
});

export const getExplorerMarkets = (countryCode: string, marketType: string = 'market') => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getExplorerMarketsLoadStart());
  const url = 'https://t15cs2r44j.execute-api.us-east-2.amazonaws.com/default/getMarkets';
  let queryParams = {};
  if (countryCode == 'saved') {
    queryParams = { savedMarkets: true };
  } else {
    queryParams = { countryCode: countryCode, marketType: marketType };
  }
  const response = await api(url, { queryParams: queryParams }, true, true);
  dispatch(setExplorerMarkets(response.message.markets));
};

const getAdvancedMarkersLoadStart = () => ({
  type: GET_ADVANCED_MARKERS_LOAD_START,
});

const getAdvancedMultipleMarkersCallLoadStart = () => ({
  type: GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_START,
});

const setAdvancedListings = payload => ({
  type: GET_ADVANCED_MARKERS_LOAD_END,
  payload,
});

const getAdvancedMultipleMarkersCallLoadEnd = () => ({
  type: GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_END,
});

export const getAdvancedMarkers = (district, city, countryCode) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getAdvancedMarkersLoadStart());
  dispatch(getAdvancedMultipleMarkersCallLoadStart());

  const url = 'https://7hokm92fe0.execute-api.us-east-2.amazonaws.com/default/getAdvancedMarkers';

  let listings = [];
  let callsMade = 0;
  const limit = 1000;

  while (callsMade < 100) {
    try {
      const offset = callsMade * limit;
      const markerParam = {
        name: district,
        city: city,
        countryCode: countryCode,
        limit: limit,
        offset: offset,
      };
      let response = await api(url, { queryParams: markerParam }, true, true);
      const listingsFromBE = response.message;

      if (listingsFromBE.length > 0) {
        listings = [...listings, ...listingsFromBE];
        dispatch(setAdvancedListings(listings));
      }

      if (listingsFromBE.length < limit) {
        break;
      }

      callsMade += 1;
    } catch (e) {
      console.log('error. Ignore and run again ', e);
      callsMade += 1;
    }
  }

  dispatch(getAdvancedMultipleMarkersCallLoadEnd());
};

const getFutureDailyDataLoadStart = () => ({
  type: GET_FUTURE_DAILY_DATA_LOAD_START,
});

const getFutureDailyDataMultipleCallLoadStart = () => ({
  type: GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_START,
});

const setFutureDailyData = payload => ({
  type: GET_FUTURE_DAILY_DATA_LOAD_END,
  payload,
});

const getFutureDailyDataMultipleCallLoadEnd = () => ({
  type: GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_END,
});

export const getFutureDailyData = (district, city, countryCode) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getFutureDailyDataLoadStart());
  dispatch(getFutureDailyDataMultipleCallLoadStart());

  const url = 'https://7hokm92fe0.execute-api.us-east-2.amazonaws.com/default/getAdvancedMarkers';

  let listings = [];
  let callsMade = 0;
  const limit = 1000;

  while (callsMade < 100) {
    try {
      const offset = callsMade * limit;
      const markerParam = {
        name: district,
        city: city,
        countryCode: countryCode,
        dataTimeFrame: 'future',
        limit: limit,
        offset: offset,
      };
      let response = await api(url, { queryParams: markerParam }, true, true);
      const listingsFromBE = response.message;

      if (listingsFromBE.length > 0) {
        listings = [...listings, ...listingsFromBE];
        dispatch(setFutureDailyData(listings));
      }

      if (listingsFromBE.length < limit) {
        break;
      }

      callsMade += 1;
    } catch (e) {
      console.log('error. Ignore and run again ', e);
      callsMade += 1;
    }
  }

  dispatch(getFutureDailyDataMultipleCallLoadEnd());
};

const getMarketMonthlyPerformanceLoadStart = () => ({
  type: GET_MARKET_MONTHLY_PERFORMANCE_LOAD_START,
});

const setMarketMonthlyPerformance = payload => ({
  type: GET_MARKET_MONTHLY_PERFORMANCE_LOAD_END,
  payload,
});

export const getMarketMonthlyPerformance = (district, city, countryCode) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getAdvancedMarkersLoadStart());

  const url =
    'https://rk9tgu4joc.execute-api.us-east-2.amazonaws.com/default/getMarketMonthlyPerformance';
  const markerParam = {
    name: district,
    city: city,
    countryCode: countryCode,
  };
  let response = await api(url, { queryParams: markerParam });
  dispatch(setMarketMonthlyPerformance(response.message));
};

export const deductEstimatorCreditAction = payload => ({
  type: DEDUCT_ESTIMATOR_CREDIT,
});

export const setUserAsVerified = () => ({
  type: SET_USED_VERIFIED,
});

export const fetchVisibleMapSupply = (
  marketID: number | string,
  marketBoundary: string,
  bounds: Bounds,
  filters: any,
  sortBy: string
) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getVisibleMapSupplyLoadStart());
  const {
    dashboard: { search },
  } = getState();

  // const url = 'https://fytwsbtpl2.execute-api.us-east-2.amazonaws.com/default/getDynamicSupply';
  const url = 'https://xnxq16nesj.execute-api.us-east-2.amazonaws.com/default/getMapListings';
  const requestBody = {
    neLat: bounds.northEast.lat,
    neLng: bounds.northEast.lng,
    swLat: bounds.southWest.lat,
    swLng: bounds.southWest.lng,
    market_id: marketID,
    return_supply: true,
    marketPolygon: marketBoundary,
    sort_by: sortBy,
  };

  if (!isEmpty(filters)) {
    requestBody['filters'] = filters;
  }


  let supply = 0;

  try {
    const response = await callApi(url, { body: requestBody }, false, false, '', 'POST', true);

    if (response && response.message) {
      supply = response.message.supply;
      dispatch(setVisibleMapSupply(supply));
    }
  } catch (error) {
    console.error('Error fetching dynamic supply:', error);
  }
};

export const setUseFullMarkers = payload => ({
  type: SET_ADVANCED_FILTER_ACTIVE_STATE,
  payload,
});

export const getHiddenSubmarkets = (marketID: number) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  const url =
    'https://e40preul0i.execute-api.us-east-2.amazonaws.com/default/setUserSubmarketVisibility';
  const requestBody = {
    market_id: marketID,
    action: 'get',
  };

  try {
    dispatch(getHiddenSubmarketsLoadStart());
    const response = await callApi(url, { body: requestBody }, true, false, '', 'POST', true);
    if (response && response.message) {
      dispatch(setHiddenSubmarkets(response.message));
    }
  } catch (error) {
    console.error('Error fetching hidden submarkets:', error);
  }
};

export const toggleSubmarketVisibility = (
  marketID: number,
  submarketIDs: string[],
  action: 'hide' | 'show' | 'show_all'
) => async (dispatch: AppDispatch, getState, api) => {
  const url =
    'https://e40preul0i.execute-api.us-east-2.amazonaws.com/default/setUserSubmarketVisibility';
  const requestBody = {
    market_id: marketID,
    action: action,
    submarket_ids: submarketIDs,
  };
  try {
    dispatch(getHiddenSubmarketsLoadStart());
    await callApi(url, { body: requestBody }, true, false, '', 'POST', true);
    dispatch(getHiddenSubmarkets(marketID));
  } catch (error) {
    console.error('Error toggling submarket visibility:', error);
  }
};

const getClustersLoadStart = () => ({
  type: GET_CLUSTERS_LOAD_START,
});

const getClustersLoadEnd = (payload: any[]) => ({
  type: GET_CLUSTERS_LOAD_END,
  payload,
});

export const getClusters = (marketID: string) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getClustersLoadStart());
  const url = 'https://a1nl3szhnj.execute-api.us-east-2.amazonaws.com/default/getClusters';
  const config = {
    market_id: marketID,
  };

  let retryCount = 0;
  const maxRetries = 10;
  const retryDelay = 3000;

  try {
    while (retryCount < maxRetries) {
      const response = await api(url, { queryParams: config }, false);
      if (response && response.message) {
        const clusterStatus = response.message.cluster_status || null;
        if (clusterStatus && clusterStatus == 'processing') {
          await new Promise(resolve => setTimeout(resolve, retryDelay));
          retryCount++;
          continue;
        } else {
          dispatch(getClustersLoadEnd(response.message.clusters));
          break;
        }
      } else {
        dispatch(getClustersLoadEnd([]));
        break;
      }
    }

    if (retryCount === maxRetries) {
      console.error('Max retries reached, no clusters ready');
      dispatch(getClustersLoadEnd([]));
    }
  } catch (error) {
    console.error('Error fetching clusters:', error);
    dispatch(getClustersLoadEnd([]));
  }
};

export const getDailyOccupancyRateCalendar = (marketID: string, shouldRefresh = false) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getDailyOccupancyRateCalendarLoadStart());
  const url =
    'https://bpcd29qv4b.execute-api.us-east-2.amazonaws.com/default/getMarketDailyOccupancyCalendar';
  const config = shouldRefresh
    ? {
        market_id: marketID,
        should_refresh: shouldRefresh,
      }
    : {
        market_id: marketID,
      };
  const response = await api(url, { queryParams: config });
  dispatch(setDailyOccupancyRateCalendarData(response.message));
};

export const getMarketCachedDataWithFilters = () => ({
  type: GET_MARKET_CACHED_DATA_WITH_FILTERS,
});

export const setMarketCachedDataWithFilters = payload => ({
  type: SET_MARKET_CACHED_DATA_WITH_FILTERS,
  payload,
});


export const setNoDataWithCurrentFilter = (payload: boolean) => ({
  type: SET_NO_DATA_WITH_CURRENT_FILTER,
});



